//Stock API configuration

export const iex = {
    api_token : 'pk_b5766828402a47588e1a21313e1e8309',
    base_url : 'https://cloud.iexapis.com/stable'
};
